function replacer(match, offset, string) {
  return !offset || offset === string.length - 1
    ? ''
    : '-';
}

export function kebabCase(string) {
  return string.toLowerCase().replace(/\W+/g, replacer);
}

export function makeHash(string) {
  return encodeURIComponent(kebabCase(string));
}
